<template>
  <div>
    <v-row v-if="!empty && showDuration" justify="space-around">
      <v-col class="shrink">
        <v-list-item>
          <v-list-item-action>
            <v-icon color="primary">$freshvuehistory-duration</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('fresh-vue-history.layout.table.headers.duration') }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <history-view-duration :history="history" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col v-if="!empty" cols="12" class="text-center">
        <v-icon small color="grey">
          {{
            order === 'DESC'
              ? '$freshvuehistory-arrowup'
              : '$freshvuehistory-arrowdown'
          }}
        </v-icon>
      </v-col>
      <v-col cols="12">
        <v-timeline
          v-if="!empty"
          v-bind="$attrs"
          :dense="$vuetify.breakpoint.mobile"
        >
          <v-slide-x-transition group tag="div">
            <history-view-timeline-item
              v-for="item in history"
              :key="item.id"
              :item="item"
              :show-duration="showDuration"
            >
              <!-- passthrough slots -->
              <slot v-for="(_, name) in $slots" :slot="name" :name="name" />
              <template
                v-for="(_, name) in $scopedSlots"
                :slot="name"
                slot-scope="slotData"
              >
                <slot :name="name" v-bind="slotData" />
              </template>
            </history-view-timeline-item>
          </v-slide-x-transition>
        </v-timeline>
        <div v-else class="text-center caption grey--text">
          {{ $t('fresh-vue-history.misc.no-history') }}
        </div>
      </v-col>
      <v-col v-if="!empty" cols="12" class="text-center">
        <v-icon small color="grey">
          {{
            order === 'DESC'
              ? '$freshvuehistory-arrowup'
              : '$freshvuehistory-arrowdown'
          }}
        </v-icon>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import HistoryViewTimelineItem from './HistoryViewTimelineItem'
import HistoryViewDuration from './HistoryViewDuration'

export default {
  name: 'HistoryViewTimeline',

  components: {
    HistoryViewDuration,
    HistoryViewTimelineItem
  },

  props: {
    history: {
      type: Array,
      required: false,
      default: null
    },

    showDuration: {
      type: Boolean,
      required: false,
      default: false
    },

    order: {
      type: String,
      required: false,
      default: 'DESC',
      validator: (value) => ['DESC', 'ASC'].includes(value)
    }
  },

  computed: {
    empty() {
      return this.history?.length <= 0
    }
  }
}
</script>
